import { ActionColumnFormat } from './ColumnsFormatters/ActionColumnFormat';

export const columns = (onCheckbox, all) => {
	let formatedData = [
		{
			dataField: 'usuario',
			text: 'Usuario',
			classes: 'text-center',
		},
		{
			dataField: 'id_table',
			text: 'Asistencia',
			classes: 'text-center',
			headerClasses: 'text-center',
			formatter: ActionColumnFormat,
			formatExtraData: {
				onCheckbox,
				all,
			},
		},
	];

	//console.log(formatedData);
	return formatedData;
};
